// Initialization for the hero slider
const heroSlider = new Swiper("#hero-slider", {
  autoplay: {
    enabled: true,
    delay: 4000,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".hero-slider-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".slider-next",
    prevEl: ".slider-prev",
  },
});

// Initialization for the ads slider
const adsSlider = new Swiper("#pads-slider", {
  slidesPerView: 4,
  spaceBetween: 15,
  pagination: {
    el: ".pads-slider-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".pads-slider-next",
    prevEl: ".pads-slider-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
});

// Initialization for the partners slider
const partnersSlider = new Swiper("#partners-slider", {
  slidesPerView: 5,
  spaceBetween: 15,
  centerInsufficientSlides: true,
  navigation: {
    nextEl: ".partners-slider-next",
    prevEl: ".partners-slider-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
  },
});

// Ad Detail Gallery (Swiper + PhotoSwipe)
var PadGallery = (function() {
  var mainEl = document.getElementById('pad-gallery-main');
  if (!mainEl) return null;

  // Thumbnails Swiper (must init first)
  var thumbsSwiper = new Swiper('#pad-gallery-thumbs', {
    slidesPerView: 6,
    spaceBetween: 10,
    watchSlidesProgress: true,
    breakpoints: {
      0:   { slidesPerView: 3, spaceBetween: 8 },
      576: { slidesPerView: 4, spaceBetween: 10 },
      768: { slidesPerView: 5, spaceBetween: 10 },
      992: { slidesPerView: 6, spaceBetween: 10 }
    }
  });

  // Main Swiper
  var mainSwiper = new Swiper('#pad-gallery-main', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.pad-gallery__next',
      prevEl: '.pad-gallery__prev'
    },
    thumbs: { swiper: thumbsSwiper },
    on: {
      slideChange: function() {
        var next = this.activeIndex + 1;
        var slides = mainEl.querySelectorAll('.swiper-slide');
        if (next < slides.length) {
          var img = slides[next].querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        }
      }
    }
  });

  return { mainSwiper: mainSwiper, thumbsSwiper: thumbsSwiper };
})();
